export enum StoreAvailableAdjustmentRequestEnum {
  ALL_STATUS = '',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED'
}

export enum StoreAvailableAdjustmentRequestRemarkTypeEnum {
  CANCEL_BY_NEWER_SU = 'CANCEL_BY_NEWER_SU',
  CANCEL_BY_QI = 'CANCEL_BY_QI',
  CANCEL_BY_SG = 'CANCEL_BY_SG'
}
